import { render, staticRenderFns } from "./Panels.vue?vue&type=template&id=d4a9ba6c&scoped=true"
import script from "./Panels.vue?vue&type=script&lang=js"
export * from "./Panels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a9ba6c",
  null
  
)

export default component.exports